<template>
    <cube-scroll class="seller" :options="sellerScrollOptions">
        <div class="common-voucher common-voucher02" v-for="(item,index) in voucher_list" :key="item.vouchertemplate_id" @click="receiveVoucher(item.vouchertemplate_id)">
            <div class="par"><p>{{ $t('voucher.order_min', [item.vouchertemplate_limit]) }}</p><sub class="sign">$</sub><span>{{item.vouchertemplate_price}}</span><div class="copy">{{ $t('voucher.expired_date') }}<span>{{item.vouchertemplate_enddate_text}}</span></div></div>
            
            <!-- <i></i> -->
        </div>
    </cube-scroll>
</template>

<script>
import { Toast } from 'mint-ui'
import { getStoreVoucher, receiveVoucher } from '../../../api/homestoredetail'
import Split from './common/split'
import SupportIco from './common/support-ico/support-ico'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      voucher_list: [],
      sellerScrollOptions: {
        directionLockThreshold: 0,
        click: false
      },
      picScrollOptions: {
        scrollX: true,
        stopPropagation: true,
        directionLockThreshold: 0
      }
    }
  },
  computed: {
    store () {
      return this.data.store || {}
    }

  },
  created () {
  },
  methods: {
    fetch () {
      if (!this.fetched) {
        this.fetched = true
        getStoreVoucher(
          this.store.store_id
        ).then((res) => {
          this.voucher_list = res.result.voucher_list
        })
      }
    },
    receiveVoucher (tid) {
      receiveVoucher(
        tid
      ).then((res) => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  components: {
    SupportIco,
    Split
  }
}
</script>

<style lang="stylus" scoped>
    .seller
        height: 100%
        text-align: left
    .common-voucher{margin:0.5rem auto}

</style>
